
import React, { useState } from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import styled from 'styled-components';
import Button from '../../forms/Button';
import GetState from '../../GetState';
import ManagementRow from '../../table/ManagementRow';
import { formatCurrency, generateId, shortHandDate, translate } from '../../utility/functions';
import { userRoles } from '../../RoleProtected';
import Table from '../../table/Table';
import Input from '../../forms/Input';
import Select from '../../forms/Select';
import Checkbox from '../../forms/Checkbox';
import { HSOptions } from '../../../constants/HSOptions';
import Radio from '../../forms/Radio';
import LocationSelectors from '../../forms/formComponents/LocationSelectors';
import TerminalIDsSelector from '../../forms/formComponents/TerminalIDsSelector';
import Preput from '../../forms/Preput';
import ModalFactory from '../../Modal';
import Form from '../../forms/Form';
import HamQuest from '../../api/HamQuestGiver';
import RequireFeature, { Features } from '../../RequireFeature';
import UpgradeAndAutoSelect from '../../forms/formComponents/UpgradeAndAutoSelect';

const PlateReadAwards = ({ ...props }) => {
    const [plateAwardsList, refreshPlateAwardsList] = GetState(QuestRoute.plateReads.plateAwards); 
    const [washClubDetails] = GetState(QuestRoute.washClubs.detail);
    
    const addPlateAward = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Add New Plate Award',
            body: (
                <Form 
                    inputs={{
                        name: '',
                        details: '',
                        itemId: '',
                        awardType: '',
                        discountValue: '',
                        expires: '',
                        allowUpgrades: '',
                        autoSelect: '',
                        locations: [],
                        terminalIds: [],
                        message: '',
                        kioskSubTypeIds: [],
                    }}                 
                    onSubmit={e => 
                        HamQuest.post(QuestRoute.plateReads.plateAwards, {...e})
                        .then(() => {refreshPlateAwardsList(); ModalFactory.close(id);})
                        .catch(ex => 
                            {ModalFactory.update({
                                id,
                                type: 'error',
                                title: 'Error!',
                                body: <>{ex.errorMessage || ex.error?.errorMessage}</>
                            });})}
                    text='Add'
                >
                    {({values}) => <PlateReadAwardsForm values={values} />}
                </Form>
            )           
        });
    }    
    const editPlateAward =  (award) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${award.itemName}`,
            body: (
                <Form
                    inputs={{ ...award }}
                    onSubmit={e => HamQuest.put(QuestRoute.plateReads.plateAward(e.awardId), { ...e })
                        .then(() => {
                            refreshPlateAwardsList();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) => <PlateReadAwardsForm values={values} editing />}
                </Form>
            )
        })        
    }
    const deletePlateAward = (award) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${award.name}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Plate Read Award',
                body: `Deleting ${award.name}`,
                callback: () => HamQuest.delete(QuestRoute.plateReads.plateAward(award.awardId))
            },
            confirmed: {
                title: 'Success',
                body: `${award.name} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshPlateAwardsList()
        })        
    }

    const PlateReadAwardsForm = ({values, editing = false, ...props}) => (
        <>
            <Input label='Name' name='name' required />
            <Preput label='Details' name='details' />
            {/* <Select
                label='Kiosk Item'
                name='itemId'
                getOptions={QuestRoute.kiosks.wash}
                buildOptions={e => {
                    e.label = e.name;
                    e.value = e.id;
                }}
                required
            /> */}
            <Select
                label='Award Type'
                name='awardType'
                options={HSOptions.plateReads.awardType}
                required
                disabled={editing}
            />
            {values.awardType !== 'DollarDiscTrans' && (
                <Radio
                    label='Discounted Item'
                    name='itemId'
                    getOptions={QuestRoute.kiosks.wash}
                    buildOptions={(e) => {
                        e.label = e.name;
                        e.value = e.id;
                    }}
                    required
                />
            )}
            <Input
                label='Value'
                name='discountValue'
                type='price'
                required
                disable={values.awardType === 'Item'}
            />
            <Input
                label='Default Expiration (Days)'
                name='expires'
                type='number'
                min={1}
                max={365}
                step={1}
                required
            />
            <UpgradeAndAutoSelect
                isAward={true} 
                autoSelectFieldName="autoSelect"
            />
            <LocationSelectors />
            <TerminalIDsSelector />
        </>
    )

    const tableConf = {
        data: plateAwardsList,
        controls: [
            <Button onClick={addPlateAward}>Add New</Button>            
        ],
        headers: [
            {
                label: 'Award Name',
                propKey: 'name',
            }, {
                label: 'Award Type',
                propKey: 'awardType',
                options: true,
            }, {
                label: 'Kiosk Item',
                propKey: 'itemName',
                options: true,
            }, {
                label: 'Discount Value',
                propKey: 'discountValue',
            }, {
                label: 'Default Expiration (Days)',
                propKey: 'expires',
            },          
        ],
        renderFormat: (e) => (
            <ManagementRow 
                key={generateId()}
                controls={[
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={()=> editPlateAward(e)}>Edit</Button>,
                    <Button roles={userRoles.editProducts} key={generateId()} onClick={()=> deletePlateAward(e)}>Delete</Button>
                ]}
            >
                <td>{e.name}</td>               
                <td>{translate(e.awardType)}</td>
                <td>{e.itemName}</td>
                <td>{formatCurrency(e.discountValue)}</td>
                <td>{e.expires}</td>
            </ManagementRow>
        )
    }

    return (
        <RequireFeature requiredFeatures={Features.PlateReads}>
            <Table config ={tableConf} />
        </RequireFeature>       
    ); 
}

export default PlateReadAwards;